import { render, staticRenderFns } from "./BroadcastsComponent.vue?vue&type=template&id=17608b46&scoped=true"
import script from "./BroadcastsComponent.vue?vue&type=script&lang=js"
export * from "./BroadcastsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17608b46",
  null
  
)

export default component.exports